import React from 'react'
import { FlatList } from 'react-native'
import PropTypes from 'prop-types'

import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import PaymentOption from '../PaymentOption'

import styles from './PaymentOptions.Styles'
import { Metrics } from '../../Themes'

function PaymentOptions({
  options,
  onOptionPress,
  theme,
  ...props
}) {

  const keyExtractor = ({ id }, index) => id + index
  const renderItem = ({ item, index }) => <PaymentOption onPress={() => onOptionPress(item, index)} {...item} theme={theme} />

  return (
    <FlatList
      horizontal
      showsHorizontalScrollIndicator={false}
      snapToInterval={Metrics.paymentOptionWidth + Metrics.paymentOptionSpacing * 2}
      decelerationRate={0.8}
      keyExtractor={keyExtractor}
      data={options}
      renderItem={renderItem}
      style={styles.container}
      {...props}
    />
  )
}

PaymentOption.defaultProps = {
  options: [],
  theme: {
    name: 'light',
    colors: LightThemeColors
  }
}

PaymentOptions.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      icon: PropTypes.any,
    })
  ),
  onOptionPress: PropTypes.func,
  theme: PropTypes.object,
}

export default PaymentOptions
